import Vue from 'vue';
import { Form } from './form.js';
import Pager from './pager.js';
import dropdown from './ui/dropdown.vue';
import checkbox from './ui/checkbox.vue';
import CheckboxGroup from './ui/checkboxGroup.vue';
import popup from './ui/popup.vue';
import datepick from './ui/datepick.vue';
import s3 from './ui/s3.vue';
import pagination from './ui/pagination.vue';
import googleMap from './ui/googleMap.vue';
import AppMessage from './ui/appMessage.vue';
import ValidationMessage from './ui/validationMessage.vue';
import TelLink from './ui/telLink.vue';

var commonMixin = {
    components: {
        dropdown: dropdown,
        checkbox: checkbox,
        CheckboxGroup: CheckboxGroup,
        datepick: datepick,
        popup: popup,
        s3: s3,
        pagination: pagination,
        googleMap: googleMap,
        AppMessage: AppMessage,
        ValidationMessage: ValidationMessage,
        TelLink: TelLink
    },
    data: function() {
        return {
            isForeground: true
        }
    },
    created: function() {
        window.dataLayer = window.dataLayer || [];
    },
    mounted: function() {
        $(window).focus(function() {
            this.isForeground = true;
        }.bind(this)).blur(function() {
            this.isForeground = false;
        }.bind(this));
    },
    methods: {
        createForm: function(opt_model) {
            return new Form(this, opt_model || {});
        },
        createPager: function(opt_limit, opt_offset) {
            return new Pager(this, opt_limit, opt_offset)
        },
        reload: function() {
            window.location.reload();
        },
        merge: function(dest, src) {
            _.forOwn(src, function(value, key) {
                this.$set(dest, key, value);
            }.bind(this));
        },
        clearArray: function(arr) {
            _.isArray(arr) && arr.splice(0, arr.length);
        },
        remove: function(arr, predicate) {
            _.forEach(arr, function(each, i) {
                if (predicate.call(null, each)) {
                    arr.splice(i, 1);
                }
            });
        },
        pathParams: function() {
            return window.data.path_params;
        },
        query: function() {
            var query = window.location.search.substring(1);
            if (!query) {
                return {};
            }
            var pairs = _.chain(query.split('&')).map(function(each) {
                var keyValue = each.split('=');
                var key = keyValue[0];
                if (keyValue.length === 1) {
                    return [key];
                }
                return [key, decodeURIComponent(keyValue[1])];
            });
            return pairs.reduce(function(result, keyValueArr) {
                var key = keyValueArr[0];
                if (key in result) {
                    var val = result[key];
                    if (_.isArray(val)) {
                        val.push(keyValueArr[1]);
                    } else {
                        result[key] = [val, keyValueArr[1]];
                    }
                } else {
                    result[key] = keyValueArr[1];
                }
                return result;
            }, {}).value();
        },
        replaceStateQuery: function(query, opt_ignores) {
            if (!history.replaceState) {
                return;
            }
            opt_ignores = opt_ignores || [];
            if (opt_ignores) {
                query = _.pickBy(query, function(value, key) {
                    return !_.includes(opt_ignores, key);
                });
            }
            var queryString = _.chain(query).map(function(value, key) {
                if (value == null) {
                    value = '';
                }
                return key + '=' + value;
            }).join('&').value();
            history.replaceState(query, null, location.pathname + '?' + queryString);
        },
        setInterval: function(callback, opt_interval, opt_invokeNow) {
            var interval = opt_interval || 0;
            var invokeNow = _.isUndefined(opt_invokeNow) ? true : opt_invokeNow;
            // 開始時にも実行
            invokeNow && callback.call(this);
            return window.setInterval(function() {
                if (!this.isForeground) {
                    return;
                }
                callback.call(this);
            }.bind(this), interval);
        }
    },
    computed: {
        location: function() {
            return window.location;
        },
        origin: function() {
            return window.location.origin;
        }
    }
};
Vue.mixin(commonMixin);
